import dynamic from "next/dynamic";

import config from "../cmsConfig";

function slugify(title) {
  // Remove any special characters from the title
  var slug = title.replace(/[^a-zA-Z0-9 \-]/g, "");

  // Replace multiple spaces with a single hyphen
  slug = slug.replace(/\s+/g, "-");

  // Convert the title to lowercase
  slug = slug.toLowerCase();

  return slug;
}

const SlugControl = ({ onChange, forID, value, classNameWrapper }) => {
  const handleChange = (e) => {
    onChange(slugify(e.target.value));
  };

  return (
    <input
      id={forID}
      className={classNameWrapper}
      type="text"
      value={value}
      onChange={handleChange}
      style={{ width: "100%" }}
    />
  );
};

const Admin = dynamic(
  () =>
    import("netlify-cms-app").then((cms) => {
      cms.init({ config });
      cms.registerWidget("slug", SlugControl);
    }),
  { ssr: false }
);

export default Admin;
